
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, MoreHorizontal, Bell, Search } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuGroup,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import NavLink from './NavLink';
import { NavItem } from './types';

interface DesktopNavProps {
  mainNavLinks: NavItem[];
  extraNavLinks: NavItem[];
}

const DesktopNav: React.FC<DesktopNavProps> = ({ mainNavLinks, extraNavLinks }) => {
  const navigate = useNavigate();
  
  return (
    <nav className="hidden md:flex items-center gap-1">
      {mainNavLinks.map((link, index) => (
        <div key={link.path} className="animate-fade-in" style={{ animationDelay: `${index * 50}ms` }}>
          <NavLink 
            to={link.path} 
            icon={link.icon} 
            label={link.label} 
          />
        </div>
      ))}
      
      {extraNavLinks.length > 0 && (
        <div className="animate-fade-in" style={{ animationDelay: `${mainNavLinks.length * 50}ms` }}>
          <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center gap-2 text-gray-300 hover:text-neon-green transition-colors duration-300 px-3 py-2">
              <MoreHorizontal className="h-5 w-5" />
              <span className="font-medium sr-only">More</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48 bg-black/90 backdrop-blur-xl border border-white/10 shadow-neon-green/10 max-h-[calc(100vh-80px)] overflow-y-auto">
              <DropdownMenuGroup>
                {extraNavLinks.map((link) => (
                  <DropdownMenuItem 
                    key={link.path} 
                    onClick={() => navigate(link.path)}
                    className="text-white hover:text-neon-green focus:text-neon-green focus:bg-white/5"
                  >
                    {link.icon}
                    <span className="ml-2">{link.label}</span>
                  </DropdownMenuItem>
                ))}
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
    </nav>
  );
};

export default DesktopNav;
